import fileSaver from 'file-saver';
import path from 'path';

/**
 * 下载文件
 * @param { string } url 下载链接
 * @param { string= } name 文件名，默认为 url 的文件名
 * @param { boolean=false} encode 是否需要encode,针对 url 中含有特殊字符，如 +
 */
export function download(url, name, encode = false) {
	try {
		if (!url) {
			throw new Error('没有下载地址');
		}
		// 判断是不是blob 对象
		if (url instanceof Blob) {
			fileSaver.saveAs(url, name);
			return;
		}

		// TODO: 待优化
		let downloadUrl = url;
		let fileName = name || path.basename(url);
		if (encode) {
			let encodeFileName = encodeURIComponent(fileName);
			const filePath = path.dirname(url);
			downloadUrl = filePath + '/' + encodeFileName;
			fileName = name || decodeURIComponent(encodeFileName);
		}
		// 根据 url 获取文件拓展名
		const extname = path.extname(downloadUrl);
		const downloadName = fileName.endsWith(extname) ? fileName : fileName + extname;

		fileSaver.saveAs(downloadUrl, downloadName);
	} catch (e) {
		console.error(e);
	}
}
